import "./input.scss";
import React from "react";
import { type IconProp } from "@fortawesome/fontawesome-svg-core";
import FontAwesomeLight from "../../../app/Utilities/Platform/FontAwesome/FontAwesomeLight";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    icon: IconProp;
    label: string;
    showLabel?: boolean;
    onClear?: () => void;
}

export default class Input extends React.Component<Props> {
    public static defaultProps = {
        showLabel: true,
    };

    public render(): React.ReactNode {
        const { icon, label, showLabel, onClear, ...props } = this.props;

        return (
            <label className="block">
                {showLabel && label}
                <div className="form-input">
                    <div className="input-icon left">
                        <FontAwesomeLight icon={icon} />
                    </div>
                    <input
                        placeholder={label}
                        {...props}
                    />
                    {(typeof onClear === "function" && !!this.props.value) && (
                        <div
                            className="input-icon right clickable"
                            onClick={onClear}
                        >
                            <FontAwesomeLight icon="times" />
                        </div>
                    )}
                </div>
            </label>
        );
    }
}
